export function goBackInBrowserHistory(step = -1) {
    window.history.go(step);
}
